import React from "react";

export function Icon(props) {
    return (
        <i className={"fa " + props.type}></i>
    );
}
